import React, { useCallback, useEffect } from "react";

// video in the side. not to be confused with JobFeatureVid, a video provided by employer

const styles = {
  videoStyle: {
    position: "absolute",
    top: "0%",
    left: "-1%",
    width: "102%",
    height: "100%",
    // height: "178.98%",
    pointerEvents: "none",
  },
};

class InnerVid extends React.PureComponent {
  componentDidMount = () => {
    const { src, setYtScriptLoaded } = this.props;
    if (!window.YT && setYtScriptLoaded !== null) {
      // If not, load the script asynchronously
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";

      // onYouTubeIframeAPIReady will load the video after the script is loaded
      window.onYouTubeIframeAPIReady = () => {
        setYtScriptLoaded(true);
        this.loadVideo();
      };

      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
      // If script is already there, load the video directly
      // console.log("YT already loaded, loading vid", this.props);
      this.loadVideo();
    }
  };

  loadVideo = () => {
    const { src } = this.props;

    // the Player object is created uniquely based on the id in props
    this.player = new window.YT.Player(`youtube-player-${src}`, {
      videoId: src,
      events: {
        onReady: this.onPlayerReady,
        onStateChange: (event) => {
          console.log2(
            "onStateChange",
            this.props,
            event.target.getPlayerState()
          );
        },
      },
      playerVars: {
        enablejsapi: 1,
        autoplay: 1,
        mute: 1,
        controls: 0,
        loop: 1,
        showinfo: 0,
        autohide: 1,
        playlist: src,
      },
    });
  };

  onPlayerReady = (event) => {
    const player = event.target;
    console.log2("playerstate", this.props, player.getPlayerState());
    if (player.getPlayerState() === -1) {
      console.log2("nextVideo", this.props);
      player.nextVideo();
    }
  };

  render = () => {
    const { src, loadPct } = this.props;
    return (
      <div style={{ ...styles.videoStyle }} id={`youtube-player-${src}`} />
    );
  };
}

export default InnerVid;
